import { useContext, useRef } from "react";
import MultiComparisonComponent from "../../Dashboard/Component/MultiComparisonComponent";
import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import MUISelect from "../../../Component/UI/MUISelect/MUISelect";
import classes from "./BrandSummary.module.css"
import { AuthContext } from "../../../context/auth-context";
import { filterKey } from "../BrandAudit";
import Checkbox from "@mui/material/Checkbox";
import { tab } from "../BrandScore/BrandScore";

export default function BrandSummary() {
  const discoveryCtx = useContext(DiscoveryContext);
  const { user } = useContext(AuthContext);
  const customerId = user?.customer_id || 0;
  let primary_llm = discoveryCtx.primary_llm;
  let llms = discoveryCtx.llm;
  let market = discoveryCtx.markets[0];
  let selectedMarket = discoveryCtx.state.selectdMarket;
  const id = "Brand_Summary";
  let uniqueKey=`${id}_${selectedMarket}`
  const { checked } = useIsSelectedSection({ id ,uniqueKey});

  const getBrandScores = (type) => {
    const brandScoresMap = {};
    // let mainBrandProduct = "";

    llms?.forEach((llm) => {
      const scores = discoveryCtx?.brand_scores?.[llm] || {};
      const market = discoveryCtx.markets[0];
      const categories = Object.keys(scores);

      categories?.forEach((category) => {
        const categoryScores = scores[category] || {};
        const marketScores = categoryScores[selectedMarket] || [];

        if (!Array.isArray(marketScores) || marketScores.length === 0) {
          console.warn(`No marketScores found for category "${category}"`);
          return;
        }
        // First valid entry sets the main brand product
        // if (!mainBrandProduct) {
        //   mainBrandProduct = marketScores[0].name;
        // }

        if (!brandScoresMap[llm]) {
          brandScoresMap[llm] = {};
        }

        brandScoresMap[llm][category] = marketScores.map((item) => {
          if (!item || !(type in item)) {
            console.warn(
              `Missing key "${type}" in marketScores for llm "${llm}", category "${category}"`
            );
            return null; 
          }
          return item[type];
        });
      });
    });

    return { brandScoresMap };
  };

  const getIndexScoreMetaData = () => {
    let indexScoreMetaData = [];
    llms.forEach((llm) => {
      const brandIndexScores = discoveryCtx?.brand_scores?.[llm] || {};
      const categories = Object.keys(brandIndexScores);
      categories.map((category) => {
        indexScoreMetaData[category] = {};
        const marketScores = brandIndexScores[category] || {};
        const primaryMarketScore = marketScores[selectedMarket] || [];
        console.log("primaryMarketScore", primaryMarketScore);
        indexScoreMetaData = indexScoreMetaData.concat(
          primaryMarketScore.slice(0, 1).map((score) => {
            return {
              ...score,
              category: category,
              market: selectedMarket,
              llm: llm,
              persona: "General Persona",
              geography: "",
            };
          })
        );
      });
    });
    return indexScoreMetaData;
  };

  return (
    <>
      <br />
      <div>
        <div className={classes.dropdownWrapper}>
          <div className="Heading-checkbox">
            <h5>Brand Summary</h5>

            {discoveryCtx.state.showReportCheckbox && (
              <Checkbox
                checked={checked}
                onChange={() => {
                  discoveryCtx?.clickComponentCheckbox({
                    uniqueKey,
                    filter: {
                      id: id,
                      title: "Brand Summary",
                      tab: tab.brandOverview,
                      uniqueKey,
                      category:null,
                      llm:null,
                    },
                    checked,
                  });
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
            )}
          </div>
          <MUISelect
            fullWidth={false}
            optionValue={discoveryCtx.state.selectdMarket}
            label={"Market"}
            id={filterKey.market}
            options={(discoveryCtx?.markets || []).map((market) => {
              return {
                name: market,
                value: market,
              };
            })}
            onChange={(e) => {
              discoveryCtx.updateSelectedMarket(e.target.value);
            }}
          />
        </div>
      </div>
      <hr />
      <MultiComparisonComponent
        fetchRealTimeActionsSources={() => {}}
        sourceURLIds={[]}
        reachSourceData={{}}
        sentimentSourceData={{}}
        categoryDimensionRatingSource={{}}
        secCategoryIndexScoreMetaData={{}}
        coreAttSourceData={{}}
        positiveAttSource={{}}
        negativeAttSource={{}}
        customerId={customerId}
        selectedInput={{
          llm: primary_llm,
          market: selectedMarket,
          persona: "General Persona",
          brand: discoveryCtx.entity,
          product: null,
          geography: "",
          category: "",
        }}
        productTaxonomyData={{}}
        secCategoryBrandFav={{}}
        secCategoryReach={{}}
        secCategoryBrandIndex={{}}
        indexScoreMetaData={getIndexScoreMetaData()}
        compCoreAttributes={{}}
        compCategoryDimensions={{}}
        pastCompCategoryDimensions={{}}
        pastCompCoreAttributes={{}}
        pastsecCategoryBrandIndex={{}}
        pastIndexScoreObj={{}}
        brandIndex={getBrandScores("total").brandScoresMap}
        brandReach={getBrandScores("rank").brandScoresMap}
        brandFav={getBrandScores("favorability").brandScoresMap}
        positiveAttributes={{}}
        negativeAttributes={{}}
        llmDomains={{}}
        geoLogo={{}}
        activeTab={"category"}
        brandDomains={{}}
        brandProduct={discoveryCtx.entity}
        type={discoveryCtx.type == "brand" ? "Brand" : "Product"}
        brandProductCategory={discoveryCtx.category}
        isBrandAuditPage={true}
        isBrandAuditMarketPage={true}
        isOverview={true}
        id={id}
      />
    </>
  );
}
